import request from '@/utils/request'
/************************************积分通用接口*******************************************/





/************************************积分规则*******************************************/

// 获取积分规则详情
export async function api_getPointRule(params) {
  return request({
    url: '/rest/member/point/rule',
    method: 'get',
    params,
  })
}
// 获取列表数据
export async function api_getRuleList(params) {
  return request({
    url: '/rest/member/point/rule/list',
    method: 'get',
    params,
  })
}
// 创建规则
export async function api_postPointRule(data) {
  return request({
    url: '/rest/member/point/rule',
    method: 'post',
    data,
  })
}
// 更新规则
export async function api_putPointRule(data) {
  return request({
    url: '/rest/member/point/rule',
    method: 'put',
    data,
  })
}
// 更新规则状态
export async function api_putPointRuleSwitch(params) {
  return request({
    url: '/rest/member/point/rule/switch',
    method: 'put',
    params,
  })
}




/************************************积分任务*******************************************/
// 获取积分任务列表数据
export async function api_getTaskList(params) {
  return request({
    url: '/rest/member/point/task/list',
    method: 'get',
    params,
  })
}

// 新增积分任务
export async function api_putTaskAdd(data) {
  return request({
    url: '/rest/member/point/task/add ',
    method: 'POST',
    data,
  })
}


// 修改积分任务
export async function api_putTaskEdit(data) {
  return request({
    url: '/rest/member/point/task',
    method: 'put',
    data,
  })
}




/************************************积分流水*******************************************/

// 获取积分流水列表数据
export async function api_getFlowList(params) {
  return request({
    url: '/rest/member/point/list',
    method: 'get',
    params,
  })
}



/************************************拍照积分*******************************************/
// 获取拍照积分列表
export async function api_getPhotograpList(params) {
  return request({
    url: '/rest/member/point/apply/list',
    method: 'get',
    params,
  })
}

// 获取拍照积分规则信息
export async function api_getRuleInfoList() {
  return request({
    url: '/rest/member/photo/ruleInfo',
    method: 'get',
  })
}

// 更新拍照积分规则信息
export async function api_postUpdateRuleInfo(data) {
  return request({
    url: '/rest/member/photo/updateRuleInfo',
    method: 'post',
    data,
  })
}
